export default "__VITE_ASSET__CSZa3Xzm__"